import { app } from '@/main';
import MerchantService from '@/api/MerchantService';
import { setOauthState } from '@/router/router-utils';
import { getSessionSignup, setSessionSignup } from '@/views/Signup/session';
import { isRemoteLoading } from '@/utils/remote-loading';

const merchantService = new MerchantService();

export const OAUTH_IFRAME = '@twism:oauth-iframe';

export default async (
  links: any,
  type: 'signup' | 'connect' | 'connectApiToken',
  params: string | Object = ''
) => {
  const typeToLink = {
    signup: 'oauthSignup',
    connect: 'oauthConnect',
    connectApiToken: 'oauthApiToken'
  }[type];

  const response = await merchantService.connect(links[typeToLink], params);
  if (response && response.data && response.data.url) {
    if (type === 'signup') {
      app.$showLoaderWithLocker();
    }
    if (isRemoteLoading()) {
      window.parent.open(response.data.url, '_self');
    } else {
      window.open(response.data.url, '_self');
    }
  }

  return response;
};

export const saveOauthState = async (query: any) => {
  const response = await merchantService.getBusinessSignup(query.jwt);
  const { businessData, provider, rawData } = response.data;

  let successRedirect;

  if (query.cb === 'external' && provider.name === 'bigcommerce') {
    successRedirect = '/merchant-connect/finish';
  }

  setOauthState({
    provider,
    businessData,
    query: query,
    successRedirect,
    rawData
  });

  if (businessData.locations.length) {
    setSessionSignup({
      country: businessData.locations[0].country,
      countryIso2: businessData.locations[0].countryIso2
    });
  }
};

export const saveIframeData = async (query: any) => {
  localStorage.setItem(
    OAUTH_IFRAME,
    JSON.stringify({
      account: query.account,
      provider: query.provider
    })
  );
};

export const getWoocommerceInitialUrl = () => {
  const oauthIframeData = JSON.parse(
    localStorage.getItem(OAUTH_IFRAME) || 'null'
  );

  return `${
    process.env.VUE_APP_API_URL
  }/merchant-connect/woocommerce/oauth/signup?shop=${oauthIframeData &&
    oauthIframeData.account}`;
};
